var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sect-wrapper",style:({ height: _vm.height, width: _vm.width })},[(_vm.title)?_c('div',{staticClass:"sect-title"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"icon"}),_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._t("title-extra")],2)]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }